import Router from '@/router';
import collectionStatus from './collectionStatus';
import productivity from './productivity';
import keyWords from './keyWords';
import documentDate from './documentDate';
import documental from './documental';
import search from './search';
import { findTipospublicacao } from '@/services/tipospublicacao';
import { findSegmentos } from '@/services/segmentos';
import { findAccounts } from '@/services/account';
import { findPC } from '@/services/palavraschave';
import { findTiposObjeto } from '@/services/tipoObjeto';


const Getters = {
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  segmentos(st) {
    return st.segmentos;
  },
  tipoPublicacoes(st) {
    return st.tipoPublicacoes;
  },
  accounts(st) {
    return st.accounts.filter(account => account.role[0].name !== 'pesquisador');
  },
  palavraschave(st) {
    return st.palavraschave;
  },
  tiposObjeto(st) {
    return st.tiposObjeto;
  },
  filter(st) {
    return st.filter;
  },

};
const mutations = {
  patchFilter(st, filter) {
    st.filter = {
      ...st.filter,
      ...filter,
    };
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
  setTipoPublicacoes(state, tipoPublicacoes) {
    state.tipoPublicacoes = tipoPublicacoes;
  },
  setSegmentos(state, segmentos) {
    state.segmentos = segmentos;
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setPalavraschave(state, palavraschave) {
    state.palavraschave = palavraschave;
  },
  setTiposObjeto(state, tiposObjeto) {
    state.tiposObjeto = tiposObjeto;
  },
};
const actions = {
  afterRouteUpdate({ dispatch }) {
    dispatch('findTipospublicacao');
    dispatch('findSegmentos');
    dispatch('loadAccounts');
    dispatch('findTiposObjeto');
  },
  findTipospublicacao({ commit }) {
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setTipoPublicacoes', items));
  },
  findSegmentos({ commit }) {
    findSegmentos({ where: { idCanalPadrao: 273 } })
      .then(items => commit('setSegmentos', items));
  },
  findTiposObjeto({ commit }) {
    findTiposObjeto({ order: 'tipoObjeto ASC', where: { or: [{ idTipopublicacao: 40 }, { idTipopublicacao: 57 }] } })
      .then((items) => {
        items.push({
          id: 0,
          tipoObjeto: 'Outros',
          idTipopublicacao: 57,
        }, {
          id: 0,
          tipoObjeto: 'Outros',
          idTipopublicacao: 40,
        });
        commit('setTiposObjeto', items);
      });
  },

  loadAccounts({ commit }) {
    const settings = {
      include: 'role',
    };
    return findAccounts(settings)
      .then((accounts) => {
        commit('setAccounts', accounts.items);
      });
  },
  searchKeywords({ commit }, keyword) {
    if (keyword) {
      findPC(keyword)
        .then((keywords) => {
          commit('setPalavraschave', keywords);
        });
    }
  },
  onFilter({ commit }, filter) {
    commit('patchFilter', filter);
  },
  setFilter({ commit }, filter) {
    commit('setFilter', filter);
  },
  generateReport({ state }, report) {
    const query = {
      query: {
        type: 'simples',
        ...state.filter,
      },
    };
    if (report.includes('Descritivo')) {
      query.query.type = 'descritivo';
    }
    if (report.includes('Status do Acervo - Relatório')) {
      query.name = 'Relatório Status do Acervo';
    } else if (report.includes('Produtividade')) {
      query.name = 'Relatório Produtividade';
    } else if (report.includes('Data do Documento')) {
      query.name = 'Relatório Data do Documento';
    } else if (report.includes('Documental')) {
      query.name = 'Relatório Espécie Documental/Tipo de Objeto';
      delete query.query.type;
    } else if (report.includes('Palavras-chave')) {
      query.name = 'Relatório Palavras-chave';
    } else if (report.includes('Consulta')) {
      query.name = 'Relatório Consulta';
    }
    const { href } = Router.resolve(query);
    window.open(href, '_blank');
  },
};

export default {
  namespaced: true,
  state: {
    filter: {},
    segmentos: [],
    tipoPublicacoes: [],
    accounts: [],
    palavraschave: [],
  },
  mutations,
  getters: Getters,
  actions,
  modules: {
    collectionStatus,
    productivity,
    keyWords,
    documentDate,
    documental,
    search,
  },
};
